import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import LoginComponent from './contexts/login.context'
import { routes } from './utils/shared.module'
import UnAuthRoute from './hooks/UnAuthRoute'
import Authenticate from './hooks/AuntenticateRoute'
import FeatureLayout from './pages/feature/feature.layout'
import { authRoutes } from './path'
import ErrorBoundary from './ErrorBoundary'
import { Helmet } from 'react-helmet-async'
import { useSelector } from 'react-redux'
import UserAccess from './pages/authentication/request-access/user-access'

const unAuth = [
  {
    id: 1,
    path: '',
    element: <Navigate to={routes.login.path} />,
  },
  {
    id: 2,
    path: 'auth/login',
    element: <LoginComponent />,
  },
  {
    id: 3,
    path: 'user-invitation/:token',
    element: <UserAccess />,
  }
]
const auth = authRoutes

const AppRouter: React.FC = () => {
  const layoutsettings = useSelector((state: any) => state?.layoutsettings)
  const titleApp = useSelector((state: any) => state?.common?.appTitle)

  return (
    <>
      <Helmet>
        {/* <title>{layoutsettings?.site_title || 'CRM'}</title> */}
        <title>{`${titleApp} - ${layoutsettings?.site_title || 'Truck Tracking App'}`}</title>
        {/* <link rel='icon' href={layoutsettings?.favicon}></link> */}
      </Helmet>
      <BrowserRouter>
        <Routes>
          <Route element={<FeatureLayout />}>
            {unAuth?.map((item) => (
              <Route
                key={item?.id}
                path={item?.path}
                element={
                  <ErrorBoundary>
                    <UnAuthRoute>{item?.element}</UnAuthRoute>
                  </ErrorBoundary>
                }
              />
            ))}

            {auth?.map((item) => (
              <Route
                key={item?.id}
                path={item?.path}
                element={
                  <ErrorBoundary>
                    <Authenticate>{item?.element}</Authenticate>
                  </ErrorBoundary>
                }
              />
            ))}
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default AppRouter
